import { PRIMARY_ERRORS_FOR_ACTIVE_PRODUCT } from 'static/productValidation';

export const getMetadataProduct = (item) => {
  const hasPackageLevel = Boolean(item?.packageLevel);
  const hasGtin = Boolean(item?.gtin);
  const hasUpc12 = Boolean(item?.upc12);

  if (hasPackageLevel) {
    let result = `${item.packageLevel}`;

    if (hasGtin) return result + ` / ${item.gtin}`;

    if (hasUpc12) return result + ` / ${item.upc12}`;

    return result;
  } else {
    if (hasGtin) return `${item.gtin}`;

    if (hasUpc12) return `${item.upc12}`;

    return 'N/A';
  }
};

/* Because some fields in the additional requirements are already covered in primaryErrors */
const getPrimaryErrorFieldKeys = () => {
  return Object.keys(PRIMARY_ERRORS_FOR_ACTIVE_PRODUCT).map((name) =>
    name?.toLowerCase()
  );
};

export const filterMinimumRequirements = (
  minimumRequirements,
  primaryErrors
) => {
  const primaryErrorFieldKeys = getPrimaryErrorFieldKeys();
  const primaryErrorFieldNames = new Set(
    primaryErrors.map((error) => error?.fieldName?.toLowerCase())
  );

  return minimumRequirements.filter((requirement) => {
    const reqLowerCase = requirement?.toLowerCase();

    // Exclude if the requirement is in PRIMARY_ERRORS_FOR_ACTIVE_PRODUCT keys
    // AND also exists in the actual primaryErrors array
    const isInPrimaryKeys = primaryErrorFieldKeys.includes(reqLowerCase);
    const isInPrimaryErrors = primaryErrorFieldNames.has(reqLowerCase);

    // Keep the requirement only if it's NOT in both places
    return !(isInPrimaryKeys && isInPrimaryErrors);
  });
};

export const getErrorsForActiveProduct = (activeProduct) => {
  const primaryErrors = activeProduct?.errors ?? [];
  const minimumRequirements =
    filterMinimumRequirements(
      activeProduct?.minimumRequirementErrorFields ?? [],
      primaryErrors
    ) ?? [];

  return minimumRequirements
    .map((fieldName) => fieldName?.toLowerCase())
    .concat(primaryErrors.map((error) => error?.fieldName?.toLowerCase()));
};

export const addErrorMessage = (requireFields, activeResult) => {
  const mandatoryFields = activeResult?.errors || [];

  return requireFields?.map((errorField) => {
    const matchedError = mandatoryFields.find(
      ({ fieldName }) =>
        fieldName?.toLowerCase() === errorField?.fieldFullPath?.toLowerCase()
    );

    return {
      ...errorField,
      errorMessage: matchedError?.errorMessage,
    };
  });
};
